import React from 'react'
import styled from 'styled-components'
import { giphyRed, giphyPurple } from '@giphy/js-brand'
import { mobile } from 'shared/util/media-query'

const GetInTouchButton = styled.a`
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    font-family: 'interface', serif;
    font-size: 18px;
    background: linear-gradient(to right, ${giphyPurple}, ${giphyRed});
    background-size: 100%;
    height: 42px;
    width: 176px;
    cursor: pointer;

    ${mobile.css`
        width: 100%;
    `}
`

const GITButton = () => <GetInTouchButton href="#">Get in Touch</GetInTouchButton>

export default GITButton
